import { useRef, useState } from "react";


interface PasswordInputProps {
    id: string;
    className?: string;
    name: string;
    value: string;
    onChange: (value: any) => void;
    placeholder: string;
    maxLength: number;
}

const PasswordInput = ({ id, className, name, value, maxLength, placeholder, onChange }: PasswordInputProps) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const [visible, setVisible] = useState(false);

    const toggle = () => {
        setVisible((prev) => !prev);
    };

    return (
        <div className="input-group-password">
            <div className="input-group">
                <input
                    type={`${visible ? 'text' : 'password'}`}
                    ref={inputRef}
                    id={id}
                    className={`form-control ${className}`}
                    name={name}
                    autoComplete='off'
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    maxLength={maxLength}
                />
                <span className='input-group-text'>
                    <i className={`fa-regular ${visible ? 'fa-eye' : 'fa-eye-slash'}`}
                        onClick={toggle}
                    />
                </span>
            </div>
        </div>
    );
};

export default PasswordInput;
